import { render, staticRenderFns } from "./AppointmentsHistory.vue?vue&type=template&id=1350983a&scoped=true&"
import script from "./AppointmentsHistory.vue?vue&type=script&lang=js&"
export * from "./AppointmentsHistory.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsHistory.vue?vue&type=style&index=0&id=1350983a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350983a",
  null
  
)

export default component.exports